export default __webpack_public_path__ + "static/media/55t.43a31afe.jpg";